import { makeStyles } from "tss-react/mui";

interface IParams {
    isMobile?: boolean;
}

export const useStyle = makeStyles<IParams>()((theme, props) => {
    const { isMobile } = props;

    return {
        buttonStack: {
            marginTop: theme.spacing(2),
            gap: theme.spacing(2),
            flexDirection: isMobile ? "column" : "row-reverse",
            justifyContent: "center",
        },
    };
});
